import { useId, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ManagementDialog } from "./ManagementDialog";

export function NameInputDialog({
  open,
  title,
  initialValue = "",
  onClose,
  onSubmit,
}: {
  readonly open: boolean;
  readonly title: string;
  readonly initialValue?: string;
  readonly onClose: () => void;
  readonly onSubmit: (name: string) => void;
}) {
  if (!open) return null;
  return (
    <NameInputForm
      key={initialValue}
      title={title}
      initialValue={initialValue}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
}

function NameInputForm({
  title,
  initialValue,
  onClose,
  onSubmit,
}: Omit<Parameters<typeof NameInputDialog>[0], "open">) {
  const [name, setName] = useState(initialValue ?? "");
  const formId = useId();
  const inputId = useId();
  return (
    <ManagementDialog
      title={title}
      onClose={onClose}
      widthClassName="max-w-[440px]"
      footer={
        <>
          <Button
            type="button"
            variant="outline"
            className="rounded-full"
            onClick={onClose}
          >
            취소
          </Button>
          <Button
            type="submit"
            form={formId}
            className="rounded-full bg-sig text-white hover:bg-sig/90"
            disabled={!name.trim()}
          >
            확인
          </Button>
        </>
      }
    >
      <form
        id={formId}
        className="flex flex-col gap-2"
        onSubmit={(event) => {
          event.preventDefault();
          const trimmed = name.trim();
          if (trimmed) onSubmit(trimmed);
        }}
      >
        <label htmlFor={inputId} className="text-sm font-medium">
          이름
        </label>
        <Input
          id={inputId}
          value={name}
          onChange={(event) => setName(event.target.value)}
        />
      </form>
    </ManagementDialog>
  );
}
